import { Link } from "@mui/material";

import { toWhatsAppChatHref } from "./utils";

type WhatsAppChatLinkProps = {
  phone?: string | null;
  text?: string;
  label?: string;
  empty?: string;
};

export default function WhatsAppChatLink({
  phone,
  text,
  label = "Send invite",
  empty = "—",
}: WhatsAppChatLinkProps) {
  const href = phone?.trim() ? toWhatsAppChatHref(phone, text) : null;

  if (!href) {
    return <>{empty}</>;
  }

  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" underline="hover">
      {label}
    </Link>
  );
}
